// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__geRCg","containerItemsCenter":"Skeleton_containerItemsCenter__3ox3r"};